import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "antd";
import offerService from "services/OfferService";
export const initialState = {
  loadingOfferById: false,
  offers: [],
  offerStatus: [],
  totalRecord: 0,
  loadingOffers: false,
  loadingStatusOffer: false,
  createLoading: false,
  loadingDurations: false,
  loadingContractsType: false,
  loadingOffersByAppId: false,
  dataOffersByAppId: [],
  contractsType: [],
  loadingChangeStatus: false,
  durations: [],
  loadingBulkSendOffer: false,
};

export const GetJobOfferSSR = createAsyncThunk(
  "/JobOffer/GetAllSSR",
  async (data, { rejectWithValue }) => {
    try {
      const response = await offerService.GetOfferSSR(data);
      if (response.success === false) {
        return rejectWithValue(response.message);
      } else {
        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);

export const GetJobOfferById = createAsyncThunk(
  "/JobOffer/GetById",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await offerService.GetOfferById({ id });
      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);

export const GetOfferStatus = createAsyncThunk(
  "/JobOffer/GetJobOfferStatus",
  async (_, { rejectWithValue }) => {
    try {
      const response = await offerService.GetOfferStatus();
      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const CreateOffer = createAsyncThunk(
  "/JobOffer/Create",
  async (data, { rejectWithValue }) => {
    try {
      try {
        const response = await offerService.CreateOffer(data);

        if (response.success === false) {
          message.error({
            content: ` ${response.message}`,
          });
          return rejectWithValue(response.message);
        } else {
          message.success({
            content: ` ${response.message}`,
          });

          return response;
        }
      } catch (err) {
        return rejectWithValue(
          err.response?.data?.message || "Something Went Wrong !"
        );
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const UpdateOffer = createAsyncThunk(
  "/JobOffer/Update",
  async (data, { rejectWithValue }) => {
    try {
      const response = await offerService.UpdateOffer(data);

      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return rejectWithValue(response.message);
      } else {
        message.success({
          content: ` ${response.message}`,
        });

        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const SetActive = createAsyncThunk(
  "/JobOffer/SetIsActive",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const response = await offerService.SetActive({ id, status });
      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return response.result;
      } else {
        message.success({
          content: ` ${response.message}`,
        });
        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetContractType = createAsyncThunk(
  "/JobOffer/GetContractType",
  async (_, { rejectWithValue }) => {
    try {
      const response = await offerService.GetContractType();
      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetContractDuration = createAsyncThunk(
  "/JobOffer/GetContractDuration",
  async (_, { rejectWithValue }) => {
    try {
      const response = await offerService.GetContractDuration();
      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const ChangeStatus = createAsyncThunk(
  "/JobOffer/ChangeStatus",
  async (data, { rejectWithValue }) => {
    try {
      const response = await offerService.ChangeStatus(data);
      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return response.result;
      } else {
        message.success({
          content: ` ${response.message}`,
        });
        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const bulkSendOffer = createAsyncThunk(
  "/JobOffer/BulkChangeStatus",
  async (data, { rejectWithValue }) => {
    const { statusId, body } = data;
    try {
      const response = await offerService.BulkSendOffer({ statusId }, body);
      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return response.result;
      } else {
        message.success({
          content: ` ${response.message}`,
        });
        return response;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetOffersByApplicationId = createAsyncThunk(
  "/JobOffer/GetOffersByApplicationId",
  async ({ applicationId }, { rejectWithValue }) => {
    try {
      const response = await offerService.GetOffersByApplicationId({
        applicationId,
      });

      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const offerSlice = createSlice({
  name: "offer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetJobOfferSSR.pending, (state) => {
        state.loadingOffers = true;
      })
      .addCase(GetJobOfferSSR.fulfilled, (state, action) => {
        state.loadingOffers = false;
        state.offers = action.payload.data;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(GetJobOfferSSR.rejected, (state, action) => {
        state.offers = [];
        state.loadingOffers = false;
      })
      .addCase(GetJobOfferById.pending, (state) => {
        state.loadingOfferById = true;
      })
      .addCase(GetJobOfferById.fulfilled, (state, action) => {
        state.loadingOfferById = false;
      })
      .addCase(GetJobOfferById.rejected, (state, action) => {
        state.loadingOfferById = false;
      })
      .addCase(GetOfferStatus.pending, (state) => {
        state.loadingStatusOffer = true;
        state.offerStatus = [];
      })
      .addCase(GetOfferStatus.fulfilled, (state, action) => {
        state.loadingStatusOffer = false;
        state.offerStatus = action.payload;
      })
      .addCase(GetOfferStatus.rejected, (state, action) => {
        state.loadingStatusOffer = false;
        state.offerStatus = [];
      })
      .addCase(CreateOffer.pending, (state) => {
        state.createLoading = true;
      })
      .addCase(CreateOffer.fulfilled, (state, action) => {
        state.createLoading = false;
      })
      .addCase(CreateOffer.rejected, (state, action) => {
        state.createLoading = false;
      })
      .addCase(UpdateOffer.pending, (state) => {
        state.updateLoading = true;
      })
      .addCase(UpdateOffer.fulfilled, (state, action) => {
        state.updateLoading = false;
      })
      .addCase(UpdateOffer.rejected, (state, action) => {
        state.updateLoading = false;
      })
      .addCase(GetContractDuration.pending, (state) => {
        state.loadingDurations = true;
      })
      .addCase(GetContractDuration.fulfilled, (state, action) => {
        state.loadingDurations = false;
        state.durations = action.payload;
      })
      .addCase(GetContractDuration.rejected, (state, action) => {
        state.loadingDurations = false;
        state.durations = [];
      })
      .addCase(GetContractType.pending, (state) => {
        state.loadingContractsType = true;
      })
      .addCase(GetContractType.fulfilled, (state, action) => {
        state.loadingContractsType = false;
        state.contractsType = action.payload;
      })
      .addCase(GetContractType.rejected, (state, action) => {
        state.loadingContractsType = false;
        state.contractsType = [];
      })
      .addCase(ChangeStatus.pending, (state) => {
        state.loadingChangeStatus = true;
      })
      .addCase(ChangeStatus.fulfilled, (state, action) => {
        state.loadingChangeStatus = false;
      })
      .addCase(ChangeStatus.rejected, (state, action) => {
        state.loadingChangeStatus = false;
      })
      .addCase(bulkSendOffer.pending, (state) => {
        state.loadingBulkSendOffer = true;
      })
      .addCase(bulkSendOffer.fulfilled, (state, action) => {
        state.loadingBulkSendOffer = false;
      })
      .addCase(bulkSendOffer.rejected, (state, action) => {
        state.loadingBulkSendOffer = false;
      })
      .addCase(GetOffersByApplicationId.pending, (state) => {
        state.loadingOffersByAppId = true;
      })
      .addCase(GetOffersByApplicationId.fulfilled, (state, action) => {
        state.loadingOffersByAppId = false;
        state.dataOffersByAppId = action.payload;
      })
      .addCase(GetOffersByApplicationId.rejected, (state, action) => {
        state.loadingOffersByAppId = false;
        state.dataOffersByAppId = [];
      });

    //   .addCase(SetActive.pending, (state) => {
    //     state.loadingSetActive = true;
    //   })
    //   .addCase(SetActive.fulfilled, (state, action) => {
    //     state.loadingSetActive = false;
    //   })
    //   .addCase(SetActive.rejected, (state, action) => {
    //     state.loadingSetActive = false;
    //   })
  },
});

export const {} = offerSlice.actions;

export default offerSlice.reducer;
